"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _css3 = require("@emotion/css");
var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));
var _chevronRightSmall = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/chevron-right-small"));
var _context = require("./context");
var _focus = _interopRequireDefault(require("../_focus"));
var _clickable = _interopRequireDefault(require("../_clickable"));
var _icon = _interopRequireDefault(require("../icon"));
var _row = _interopRequireDefault(require("../row"));
var _sideMenuSpacer = _interopRequireDefault(require("./side-menu-spacer"));
var _expanderController = _interopRequireDefault(require("../_expander-controller"));
var _token = require("./../_utils/token");
var _isElementOfAny = _interopRequireDefault(require("./../_utils/is-element-of-any"));
var _isElementOf = _interopRequireDefault(require("./../_utils/is-element-of"));
var _focusRing = _interopRequireDefault(require("./../_styles/focus-ring"));
var _listReset = _interopRequireDefault(require("./../_styles/list-reset"));
var _text = _interopRequireDefault(require("./../_styles/text"));
var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var focus = _ref.focus,
    selected = _ref.selected,
    disabled = _ref.disabled;
  return (0, _css3.css)({
    display: "block",
    boxSizing: "border-box",
    minHeight: "".concat(parseInt(t("linkSpacingInsetVertical")) * 2 + parseInt((0, _text["default"])(t).lineHeight.split("px")[0]), "px"),
    width: "100%",
    color: t("linkForegroundColor", disabled ? "disabled" : "default"),
    backgroundColor: t("linkBackgroundColor", selected ? "selected" : "default"),
    transition: t.transitionCss("motionInteract", "background-color"),
    ":hover": !disabled ? {
      backgroundColor: t("linkBackgroundColorHover")
    } : undefined,
    ":active": !disabled ? {
      backgroundColor: t("linkBackgroundColorPressed"),
      "& [mdn-side-menu-indicator]": {
        backgroundColor: selected ? t("linkIndicatorColorSelected") : t("linkIndicatorColorPressed")
      }
    } : undefined
  }, (0, _focusRing["default"])(t.tokens, {
    offset: 0,
    focus: focus
  }));
}, ["focus", "selected", "disabled"]);
var contentStyles = (0, _css3.css)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-start",
  boxSizing: "border-box"
});
var indicatorStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var selected = _ref2.selected;
  return (0, _css3.css)({
    flexShrink: 0,
    margin: t("linkIndicatorSpacing"),
    width: t("linkIndicatorWidth"),
    alignSelf: "stretch",
    backgroundColor: selected ? t("linkIndicatorColorSelected") : "transparent",
    borderRadius: t("linkIndicatorBorderRadius"),
    transition: t.transitionCss("motionInteract", "background-color")
  });
}, ["selected"]);
var spacerStyles = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var _css;
  var depth = _ref3.depth,
    siblingsWithChildren = _ref3.siblingsWithChildren,
    open = _ref3.open,
    useIconLabel = _ref3.useIconLabel;
  var insetSpacing = t("linkSpacingInsetHorizontal");
  var indicatorWidth = t("linkIndicatorWidth") + t("linkIndicatorSpacing") * 2;
  return (0, _css3.css)((_css = {
    minWidth: useIconLabel ? 8 // magic number based off the ol' 👀
    : siblingsWithChildren ? insetSpacing : insetSpacing - indicatorWidth,
    marginInlineStart: depth > 0 ? (depth + 1) * insetSpacing : 0,
    marginInlineEnd: 0,
    transform: open ? "rotate(90deg)" : "rotate(0deg)"
  }, (0, _defineProperty2["default"])(_css, "[dir=\"rtl\"] &", {
    transform: open ? "rotate(-90deg)" : "rotate(-0deg)"
  }), (0, _defineProperty2["default"])(_css, "transition", t.transitionCss("motionExpand", "transform")), _css));
}, ["depth", "siblingsWithChildren", "open", "useIconLabel"]);
var iconLabelMountAnimation = (0, _css3.keyframes)({
  from: {
    transform: "translateX(-100%)"
  },
  to: {
    transform: "translateX(0%)"
  }
});
var iconLabelMountAnimationRTL = (0, _css3.keyframes)({
  from: {
    transform: "translateX(100%)"
  },
  to: {
    transform: "translateX(0%)"
  }
});
var labelStyles = (0, _token.memoizeTokenStyles)(function (t, _ref4) {
  var siblingsWithChildren = _ref4.siblingsWithChildren,
    _ref4$animate = _ref4.animate,
    animate = _ref4$animate === void 0 ? false : _ref4$animate;
  return (0, _css3.css)((0, _defineProperty2["default"])({
    paddingTop: t("linkSpacingInsetVertical"),
    paddingRight: t("linkSpacingInsetHorizontal"),
    paddingBottom: t("linkSpacingInsetVertical"),
    paddingLeft: siblingsWithChildren ? t("linkSpacingHorizontal") : 0,
    animation: animate ? "".concat(iconLabelMountAnimation, " ").concat(t("motionInteractDuration")) : undefined
  }, "[dir=\"rtl\"] &", {
    paddingLeft: t("linkSpacingInsetHorizontal"),
    paddingRight: siblingsWithChildren ? t("linkSpacingHorizontal") : 0,
    animation: animate ? "".concat(iconLabelMountAnimationRTL, " ").concat(t("motionInteractDuration")) : undefined
  }));
}, ["siblingsWithChildren", "animate"]);

/**
 * This component can be used to render a navigational link. Place this as a
 * child of the SideMenu component.
 */
var SideMenuLink = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SideMenuLink, _React$Component);
  var _super = _createSuper(SideMenuLink);
  function SideMenuLink() {
    var _this$props$id;
    var _this;
    (0, _classCallCheck2["default"])(this, SideMenuLink);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", (_this$props$id = _this.props.id) !== null && _this$props$id !== void 0 ? _this$props$id : (0, _uniqueId["default"])("side-menu-link-"));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isLink", (0, _isElementOfAny["default"])(_this.props.linkComponents));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isSpacer", (0, _isElementOf["default"])(_sideMenuSpacer["default"]));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "ref", /*#__PURE__*/(0, _react.createRef)());
    /**
     * Extracts all of the links and spacer components from a children object and returns them
     * as an array.
     */
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getLinksWithSpacers", function (children) {
      return _react["default"].Children.toArray(children).filter(function (child) {
        return _this.isLink(child) || _this.isSpacer(child);
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDown", function (event, parentRef) {
      if (event.key === "Escape" && _this.props.onEscape) {
        // Try to shift focus to the parent if it exists
        if (parentRef.current) {
          try {
            parentRef.current.focus();
          } catch (_) {
            // Silent error
          }
        }
        _this.props.onEscape();
      }
    });
    return _this;
  }
  (0, _createClass2["default"])(SideMenuLink, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var props = this.props;
      var icon = props.icon;
      var id = this.id;
      var label = _react["default"].Children.toArray(props.children).filter(function (element) {
        return !_this2.isLink(element) && !_this2.isSpacer(element);
      });
      var children = this.getLinksWithSpacers(props.children);
      var withChildren = children.length > 0;
      // This is true if the children object contains any links that have more
      // links nested inside of them.
      var withGrandchildren = children.filter(function (link) {
        return _this2.getLinksWithSpacers(link.props.children).length > 0;
      }).length > 0;
      var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
      return /*#__PURE__*/_react["default"].createElement(_context.Consumer, null, function (_ref5) {
        var t = _ref5.t,
          siblingsWithChildren = _ref5.siblingsWithChildren,
          useIconLabel = _ref5.useIconLabel,
          _ref5$depth = _ref5.depth,
          depth = _ref5$depth === void 0 ? 0 : _ref5$depth,
          parentRef = _ref5.parentRef;
        return /*#__PURE__*/_react["default"].createElement(_focus["default"], null, function (_ref6) {
          var focus = _ref6.focus,
            focusProps = _ref6.focusProps,
            focusTrigger = _ref6.focusTrigger;
          return /*#__PURE__*/_react["default"].createElement("li", {
            onKeyDown: function onKeyDown(event) {
              return _this2.onKeyDown(event, parentRef);
            }
          }, /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, passThroughProps, focusProps, {
            className: styles(t, {
              focus: focus && focusTrigger === "keyboard",
              selected: props.selected,
              disabled: props.disabled
            }),
            href: props.href,
            onClick: props.onClick,
            disabled: props.disabled,
            target: props.target,
            rel: props.rel,
            id: id,
            "aria-current": props.selected ? "page" : undefined,
            "aria-expanded": withChildren ? props.open : undefined,
            "aria-controls": withChildren ? "".concat(id, "-links") : undefined,
            ref: _this2.ref
          }), /*#__PURE__*/_react["default"].createElement("div", {
            className: contentStyles,
            id: "".concat(id, "-label")
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: indicatorStyles(t, props),
            "mdn-side-menu-indicator": ""
          }), withChildren && !useIconLabel ? /*#__PURE__*/_react["default"].createElement(_icon["default"], {
            tokens: _chevronRightSmall["default"],
            className: spacerStyles(t, {
              open: props.open,
              siblingsWithChildren: siblingsWithChildren,
              depth: depth
            })
          }) : /*#__PURE__*/_react["default"].createElement("div", {
            className: spacerStyles(t, {
              siblingsWithChildren: siblingsWithChildren,
              depth: depth,
              useIconLabel: useIconLabel
            })
          }), useIconLabel ? /*#__PURE__*/_react["default"].createElement("span", {
            className: labelStyles(t, {
              siblingsWithChildren: siblingsWithChildren,
              animate: true
            })
          }, props.icon ? /*#__PURE__*/_react["default"].createElement(_row["default"], {
            widths: [24]
          }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
            tokens: icon
          }, label)) : null) : /*#__PURE__*/_react["default"].createElement("span", {
            className: labelStyles(t, {
              siblingsWithChildren: siblingsWithChildren
            })
          }, icon ? /*#__PURE__*/_react["default"].createElement(_row["default"], {
            widths: [24, "fill"]
          }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
            tokens: icon
          }), " ", /*#__PURE__*/_react["default"].createElement("span", null, label)) : label))), withChildren ? /*#__PURE__*/_react["default"].createElement(_context.Provider, {
            value: {
              t: t,
              siblingsWithChildren: withGrandchildren,
              depth: depth + 1,
              parentRef: _this2.ref
            }
          }, /*#__PURE__*/_react["default"].createElement(_expanderController["default"], {
            open: props.open,
            direction: "down",
            motionDuration: parseInt(t("motionExpandDuration")),
            motionFunction: t("motionExpandFunction"),
            alwaysRenderChildren: true
          }, function (_ref7) {
            var containerProps = _ref7.containerProps,
              contentProps = _ref7.contentProps;
            return /*#__PURE__*/_react["default"].createElement("div", containerProps, /*#__PURE__*/_react["default"].createElement("ul", (0, _extends2["default"])({}, contentProps, {
              className: (0, _css3.cx)((0, _css3.css)(_listReset["default"]), contentProps.className),
              role: "group",
              id: "".concat(id, "-links"),
              "aria-labelledby": "".concat(id, "-label")
            }), children));
          })) : null);
        });
      });
    }
  }]);
  return SideMenuLink;
}(_react["default"].Component);
SideMenuLink.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The link's label, as well as any nested `SideMenuLink` elements for
   * multi-level navigation.
   */
  children: _propTypes["default"].node.isRequired,
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the SideMenuLink, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following properties,
   * they'll be ignored:
   *
   * aria-current | aria-expanded | aria-controls
   */
  "aria-*": _propTypes["default"].string,
  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,
  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,
  /**
   * If a URL is provided here, the component will behave like a link.
   *
   * Note that you must either set this prop or the `onClick` prop (or both).
   */
  href: _propTypes["default"].string,
  /**
   * Renders an Icon in the SideMenulink. The Icon is positioned
   * to the left of the label.
   * ```
   * import flashIconTokens from "@amzn/meridian-tokens/base/icon/flash"
   *
   * <SideMenuLink
   *   onClick={handleClick}
   *   icon={flashIconTokens}
   * >
   * ```
   */
  icon: _propTypes["default"].object,
  /**
   * Sets an `id` attribute on the component's link element.
   *
   * Use this for testing or for accessibility. Do not use this in order to
   * apply override styles to the component. The markup and styles rendered by
   * Meridian components are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,
  /**
   * The component that will render any SideMenu link children. Inherits the
   * value passed to the "linkComponents" prop of SideMenu by default.
   *
   * NOTE: If your component is wrapped in a higher-order component, make sure
   * that the resulting component has a static property `WrappedComponent`
   * that is equivalent your original component.
   */
  linkComponents: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])),
  /**
   * Use this to toggle the visibility of nested SideMenuLink's inside this
   * link.
   *
   * When `open` is set to true the nested side menu links are visible and able to be
   * interacted with.
   *
   * NOTE: Only one layer of nesting is supported. For a second layer of nesting pages
   * consider using a [tab group](https://meridian.a2z.com/components/tab/?platform=react-web).
   *
   */
  open: _propTypes["default"].bool,
  /**
   * The relationship of the linked URL to the current page. Only applicable if
   * `href` is set.
   *
   * See docs for the [a tag's rel attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-rel) for details.
   */
  rel: _propTypes["default"].string,
  /**
   * Use this to mark the link as selected. A link is usually considered
   * selected if the page it references is currently loaded.
   */
  selected: _propTypes["default"].bool,
  /**
   * Determine where the linked URL is displayed. This is only applicable if
   * `href` is provided but `onClick` is not.
   *
   * IMPORTANT: If you set this prop to `"_blank"`, make sure to set `rel` to
   * `"noopener noreferrer"` to avoid performance and security issues.
   *
   * See docs for the [a tag's target attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target) for details.
   */
  target: _propTypes["default"].string,
  /**
   * This will be triggered when the component is clicked. If the `href` prop is
   * set, that value will be passed as the first argument to this function.
   *
   * If this prop is used along with the `href` prop, the default link behavior
   * of the component will be disabled and the click handler will be responsible
   * for implementing the behavior of the component.
   *
   * These features make it easy to implement accessible client-side navigation.
   * If you have a client-side navigation function of the form `navigate(<url>)`, you
   * can integrate it into this component by setting a URL via `href` and then
   * passing `navigate` directly to this prop (i.e. `href={url} onClick={navigate}`).
   * See the [Routing and navigation guide](https://meridian.a2z.com/for-developers/guides/routing-and-navigation/?platform=reactjs)
   * for details.
   *
   * Note that you must set either this prop or the `href` prop (or both).
   */
  onClick: _propTypes["default"].func,
  /**
   * Use this prop to collapse nested groups when the user presses the "escape"
   * key while focused on a nested link.
   *
   * This function is will only be called if the link is a nested link. Several
   * Several things will happen if this function is present and the user presses
   * the "escape" key while focusing on the link. First, this `onEscape` function
   * will be called. Second, the parent link will gain focus.
   *
   * ```
   * <SideMenuLink
   *   open={openLinkHash === "group-1"}
   *   onClick={() => {
   *     if(openLinkHash !== "group-1") {
   *       setOpenLinkHash("group-1")
   *     } else {
   *       setOpenLinkHash(null)
   *     }
   *   }}
   * >
   *   Group 1
   *   <SideMenuLink
   *     selected={path === "/path"}
   *     href="/path"
   *     // Close the group when the user presses the "escape" key
   *     onEscape={() => setOpenLinkHash(null)}
   *   >
   *     Path
   *   </SideMenuLink>
   * </SideMenuLink>
   * ```
   */
  onEscape: _propTypes["default"].func
} : {};
var _default = SideMenuLink;
exports["default"] = _default;